<script>
import Swal from "sweetalert2";
import MultiSelect from "vue-multiselect";
import carousel from "vue-owl-carousel";

// Custom components
import TemplateData from "../../hotelDirectory/template.vue";
import { authComputed, authMethods } from "@/state/helpers";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

export default {
  page: {
    title: "homePage",
  },
  components: {
    MultiSelect,
    carousel,
    TemplateData,
  },
  data() {
    return {
      brands: [],
      selected: "",
      brandThemes: [],
      themeSelected: "Add Theme",
      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 300,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },
      // Template Relate Variables
      templateOptions: [
        {
          id: 1,
          title: "Template With Box View",
          img: "template_1",
          is_img_template: false,
          is_icon_template: true,
          insideHtml: `
            <div class="container">
              <div class="d-flex align-items-center flex-wrap justify-content-center">
                <template v-for="(menu, index) in PageData">
                  <div :key="index" v-if="menu.is_active_super_panel!==undefined? menu.is_active_super_panel && menu.is_plan_purchased && menu.is_active && menu.feature_code!=101:menu.is_active" >
                    <div class="mobile-box-card d-flex align-items-center justify-content-center text-dark template-theme-border template-menu-bg position-relative">
                        <div class="text-center">
                          <i :class="menu.icon!==null?menu.icon:menu.app_feature_icon" class="mb-2 fs-4 template-theme-icon"></i>
                          <p class="mb-0 template-menu-font">{{ menu.name }}</p>
                        </div>
                    </div>
                  </div>
                </template>
                <div class="mt-3 px-4 w-100">
                  <button class="hotel-btn btn w-100 p-2 fs-5">Logout</button>
                </div>
              </div>
            </div>`,
        },
        {
          id: 2,
          title: "Template With List View",
          img: "template_4",
          is_img_template: false,
          is_icon_template: false,
          insideHtml: `
          <div class="px-4">
            <div class="row">
            <template v-for="(menu, index) in PageData">
                <div :key="index" v-if="menu.is_active_super_panel!==undefined? menu.is_active_super_panel && menu.is_plan_purchased && menu.is_active && menu.feature_code!=101:menu.is_active" >
                <div class="template-menu-bg template-theme-border p-3 rounded-3 mb-3 position-relative">
                  <div class="text-center">
                    <h6 class="mb-0 template-menu-font">{{ menu.name }}</h6>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="mb-3">
            <button class="hotel-btn w-100 btn template-theme-border p-2 fs-5">Logout</button>
          </div>
        </div>`,
        },
        {
          id: 3,
          title: "Template With Image List View",
          img: "template_2",
          is_img_template: true,
          is_icon_template: false,
          insideHtml: `
          <div class="px-3">
            <div class="row">
              <template v-for="(menu, index) in PageData">
                <div :key="index" v-if="menu.is_active_super_panel!==undefined? menu.is_active_super_panel && menu.is_plan_purchased && menu.is_active && menu.feature_code!=101:menu.is_active" >
                  <div class="second-template position-relative mb-2" :style="{'background-image': getImage(menu.image),}">
                    <h6 class="bg-template-text mb-0 template-menu-font">{{ menu.name }}</h6>
                  </div>
                </div>
              </template>
            </div>
            <div class="mb-3">
              <button class="hotel-btn w-100 btn template-theme-border p-2 fs-5">Logout</button>
            </div>
          </div>`,
        },
        {
          id: 4,
          title: "Template With Image Box View",
          img: "template_3",
          is_img_template: true,
          is_icon_template: false,
          insideHtml: `
            <div class="container">     
              <div class='row justify-content-center'>
                <template v-for="(menu, index) in PageData">
                  <div :key="index" class="col-md-5 px-2" v-if="menu.is_active_super_panel!==undefined? menu.is_active_super_panel && menu.is_plan_purchased && menu.is_active && menu.feature_code!=101:menu.is_active" >
                    <div class="third-template position-relative mb-3" :style="{'background-image': getImage(menu.image),}">
                      <p class="bg-template-text w-100 mb-0 template-menu-font">{{ menu.name }}</p>
                    </div>
                  </div>
                </template>
              </div>         
              <div class="px-4 mb-3">
                <button class="hotel-btn w-100 btn template-theme-border p-2 fs-5">Logout</button>
              </div>
            </div>
          `,
        },
      ],
      selectedTemplate: null,
      headerData: {
        isSingleImg: false,
      },
      originalId: "",
      themerData: "",
      colorData: {
        theme: "",
        theme_font: "",
        theme_icon: "",
        theme_border: "",
        title_bg: "#",
        title_font: "",
        menu_bg: "",
        menu_font: "",
        btn_bg: "",
        btn_font: "",
        btn_border: "",
      },
      headerDataImages: [
        {
          image: require("@/assets/images/ThatHotel.png"),
        },
        {
          image: require("@/assets/images/ThatHotelAgain.png"),
        },
      ],
      headerImageLoading: false,
      menuPage: [
        {
          icon: "fas fa-book",
          image: null,
          is_active: true,
          name: "My Booking",
          page_condition: [],
          priority_order: 1,
          slug_name: "my-booking",
        },
        {
          icon: "fas fa-bed",
          image: null,
          is_active: true,
          name: "My Room",
          page_condition: [],
          priority_order: 2,
          slug_name: "my-room",
        },
        {
          icon: "fas fa-map-marked-alt",
          image: null,
          is_active: true,
          name: "location",
          page_condition: [],
          priority_order: 1,
          slug_name: "location",
        },
        {
          icon: "fas fa-phone-alt",
          image: null,
          is_active: true,
          name: "Call FrontDesk",
          page_condition: [],
          priority_order: 1,
          slug_name: "Call FrontDesk",
        },
        {
          icon: "fas fa-hamburger",
          image: null,
          is_active: true,
          name: "NearBy Place",
          page_condition: [],
          priority_order: 1,
          slug_name: "NearBy Place",
        },
        {
          icon: "fas fa-user-clock",
          image: null,
          is_active: true,
          name: "Wakeup call",
          page_condition: [],
          priority_order: 1,
          slug_name: "Wakeup call",
        },
      ],
      isBtnLoading: false,
      isResetBtnLoading: false,
      imgUrl: null,
      greeting: "",
    };
  },

  computed: {
    ...authComputed,
  },
  mounted() {
    this.selectedTemplate = this.templateOptions[0];
    this.getBrandedData();
  },
  methods: {
    ...authMethods,
    /** TEMPLATE RELATED METHODS */
    async getBrandedData() {
      try {
        const response = await UserService.getBrandData();
        if (response) {
          this.brands = response;
          this.selected = response[0];
          this.brandSelector();
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for change dynamic color by status
    colorChange($evt, type) {
      this.colorData[type] = $evt.target.value;
      this.setThemeColor($evt.target.value, type);
      if (this.selected == "Add Theme") {
        this.headerData.name = "";
      }
      if (this.selected !== "Add Theme") {
        this.headerData.name = this.themeSelected.name;
      }
    },
    // Method is use to handle header form data submission
    async handleHeaderSubmit() {
      this.isBtnLoading = true;
      this.headerData.color_setting = this.colorData;
      if (this.themeSelected !== "Add Theme") {
        try {
          const response = await UserService.editBrandThemeData(
            this.selected.id,
            this.themeSelected.id,
            { ...this.headerData }
          );
          this.brandThemes = this.brandThemes.map((theme) => {
            if (theme.id == response.id) {
              theme = response;
            }
            return theme;
          });

          if (response) {
            this.headerData = response;
            this.isBtnLoading = false;
            Middleware.notification(
              "Changes successfully applied !!",
              "success"
            );
          }
        } catch (error) {
          this.isBtnLoading = false;
          errorHandler(error);
        }
      } else if (this.themeSelected == "Add Theme") {
        if (
          this.headerData.name !== "" &&
          this.headerData.name !== undefined &&
          this.headerData.name !== null
        ) {
          try {
            const response = await UserService.addBrandThemeData(
              this.selected.id,
              {
                brand: this.selected.id,
                ...this.headerData,
              }
            );
            if (response) {
              this.headerData = response;
              this.brandThemes.push(response);
              this.isBtnLoading = false;
              Middleware.notification(
                "Changes successfully applied !!",
                "success"
              );
            }
          } catch (error) {
            this.isBtnLoading = false;
            errorHandler(error);
          }
        } else {
          this.isBtnLoading = false;
          Middleware.notification("Theme name can't be empty !!", "error");
        }
      }
    },

    // Method is used to reset header data
    resetHeaderData() {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to reset data!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes !",
      }).then((result) => {
        if (result.value) {
          this.setDynamicCOlor(this.themerData);
          if (this.themeSelected == "Add Theme") {
            this.headerData.name = "";
            this.doChanges();
          }
          if (this.themeSelected !== "Add Theme") {
            this.headerData.name = this.themeSelected.name;
          }

          this.isResetBtnLoading = false;
          Middleware.notification("Template reset successful !!", "success");
        }
      });
    },
    // Method is used to delete theme
    deleteTheme() {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes !",
      }).then(async (result) => {
        if (result.value) {
          await UserService.deleteBrandThemeData(
            this.headerData.brand,
            this.headerData.id
          )
            .then((response) => {
              this.brandThemes = this.brandThemes.filter(
                (theme) => theme.id !== this.headerData.id
              );
              this.themeSelected = "Add Theme";
              this.themeSelector();
              Middleware.notification(
                "Theme successfully deleted !!",
                "danger"
              );
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    /** HEADER IMAGE RELATED METHODS */
    // Method is used to handle change header image
    changeHeaderImage(event, status) {
      if (event[0] !== undefined) {
        alert("Image Change");
        this.headerImageLoading = true;
        setTimeout(() => {
          document.querySelector(".has-icon").click();
        }, 500);
      }
    },
    // Method is use to delete image from multi image
    deleteHeaderMultiImage(image) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete image!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          alert("Delete Image");
        }
      });
    },

    /** EXTRA METHODS HELPER */
    // Method is use for make template option label dynamic
    customLabel({ title }) {
      return `${title}`;
    },
    // Method is use for get static image and return to use in image tag
    getImage(image) {
      return require("../../../assets/images/templates/" + image + ".png");
    },
    async brandSelector() {
      let newId = this.selected.id;
      try {
        const themeData = await UserService.getBrandThemeData(newId);
        this.brandThemes = themeData;
        if (themeData.length !== 0) {
          this.headerData = { ...this.headerData, ...themeData[0] };
          this.setDynamicCOlor(this.headerData.color_setting);
          this.themeSelected = themeData[0];
        } else {
          this.themeSelected = "Add Theme";
        }
        if (this.themeSelected == "Add Theme") {
          this.doChanges();
        } else {
          this.themerData = this.themeSelected.color_setting;
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    themeSelector() {
      if (this.themeSelected !== "Add Theme") {
        this.themerData = this.themeSelected.color_setting;
        this.headerData = { ...this.headerData, ...this.themeSelected };
        this.setDynamicCOlor(this.themeSelected.color_setting);
      } else {
        this.doChanges();
      }
    },
    // Method is used to set color dynamicaly
    setDynamicCOlor(colors) {
      this.colorData = {
        theme: colors["theme"],
        theme_font: colors["theme_font"],
        theme_icon: colors["theme_icon"],
        theme_border: colors["theme_border"],
        title_bg: colors["title_bg"],
        title_font: colors["title_font"],
        menu_bg: colors["menu_bg"],
        menu_font: colors["menu_font"],
        btn_bg: colors["btn_bg"],
        btn_font: colors["btn_font"],
        btn_border: colors["btn_border"],
      };
      Object.keys(this.colorData).map((key) => {
        this.setThemeColor(this.colorData[key], key);
      });
    },
    // Method  is used to set theme color
    setThemeColor(color, type) {
      let bodyStyles = document.body.style;
      bodyStyles.setProperty(
        `--template-${String(type).replaceAll("_", "-")}`,
        color
      );
    },
    doChanges() {
      this.headerData.name = null;
      this.colorData = {
        theme: "#238cf8",
        theme_font: "#ffffff",
        theme_icon: "#238cf8",
        theme_border: "#238cf8",
        title_bg: "#238cf8",
        title_font: "#ffffff",
        menu_bg: "#ffffff",
        menu_font: "#238cf8",
        btn_bg: "#238cf8",
        btn_font: "#ffffff",
        btn_border: "#ffffff",
      };
      Object.keys(this.colorData).map((key) => {
        this.setThemeColor(this.colorData[key], key);
      });
    },
  },
};
</script>

<template>
  <div>
    <b-card v-if="selected !== undefined && selected !== ''">
      <div class="row mb-3">
        <div class="col-md-2">
          <label for="">brand</label>
          <select
            class="form-control"
            v-model="selected"
            @change="brandSelector()"
          >
            <option
              v-for="(brand, index) in brands"
              :key="brand + index"
              :value="brand"
            >
              {{ brand.name }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <label for="">theme</label>
          <select
            class="form-control"
            v-model="themeSelected"
            @change="themeSelector()"
          >
            <option value="Add Theme">Add Theme</option>
            <option
              v-for="(item, index) in brandThemes"
              :key="index"
              :value="item"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>

      <!-- Design page -->
      <template v-slot:title>
        <span class="d-inline-block d-sm-none">
          <i class="far fa-user"></i>
        </span>
        <span class="d-none d-sm-inline-block">Design Page</span>
      </template>
      <div>
        <div class="row">
          <div class="col-xl-5 col-lg-6">
            <div class="iphone">
              <div class="iphone-top">
                <span class="camera"></span>
                <span class="sensor"></span>
                <span class="speaker"></span>
              </div>
              <div class="top-bar"></div>
              <div class="iphone-screen template-theme">
                <div class="py-2 px-4 position-relative template-title-bg">
                  <p class="fw-bold mb-0 text-center template-title-font">
                    {{
                      headerData
                        ? headerData.name
                          ? headerData.name
                          : "Welcome"
                        : `"Welcome To Hotel Name"`
                    }}
                  </p>
                </div>
                <div class="mobile-box">
                  <div
                    class="p-3 text-center position-relative template-title-font"
                  >
                    <img
                      v-if="headerData.isSingleImg"
                      src="@/assets/images/ThatBrandLogo.jpg"
                      alt=""
                      class="img-logo"
                    />
                    <div v-else>
                      <carousel
                        :autoplay="true"
                        :loop="true"
                        :nav="false"
                        :dots="false"
                        :responsive="{ 0: { items: 1 } }"
                        :key="headerDataImages.length"
                      >
                        <img
                          v-for="(img, index) in headerDataImages"
                          :src="img.image"
                          :key="index"
                          class="banner-img object-fit rounded"
                        />
                      </carousel>
                    </div>
                    <p class="mt-3 mb-0 template-theme-font">
                      {{ greeting }} Guest Name
                    </p>
                  </div>
                  <template v-if="menuPage.length == 0">
                    <div class="container">
                      <div class="row justify-content-center">
                        <div
                          v-for="no in 10"
                          :key="no"
                          class="placeholder-glow col-md-5 px-2 mb-3"
                        >
                          <span
                            class="placeholder placeholder-lg mobile-box-card w-100"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <TemplateData
                      :Pages="menuPage"
                      :html="selectedTemplate.insideHtml"
                      :key="selectedTemplate.id"
                    />
                  </template>
                </div>
              </div>
              <div class="buttons">
                <span class="on-off"></span>
                <span class="sleep"></span>
                <span class="up"></span>
                <span class="down"></span>
              </div>
              <div class="bottom-bar"></div>
              <div class="iphone-bottom">
                <span></span>
              </div>
            </div>
          </div>
          <div class="col-xl-7 col-lg-6">
            <div>
              <h5 class="typo__label">Select Template</h5>
              <MultiSelect
                v-model="selectedTemplate"
                placeholder="Select Template"
                label="title"
                track-by="title"
                :options="templateOptions"
                :option-height="104"
                :custom-label="customLabel"
                :show-labels="false"
                :allow-empty="false"
                class="multi-select-template w-50"
              >
                <template slot="singleLabel" slot-scope="props"
                  ><img
                    class="option-image"
                    :src="getImage(props.option.img)"
                    :alt="props.option.title"
                  /><span class="ms-2">{{ props.option.title }}</span></template
                >
                <template slot="option" slot-scope="props"
                  ><img
                    class="option-image"
                    :src="getImage(props.option.img)"
                    :alt="props.option.title"
                  />
                  <span class="ms-2">{{ props.option.title }}</span>
                </template>
              </MultiSelect>
              <div class="mt-3" v-if="headerData !== null">
                <p class="text-danger">
                  Note* : Please select color contrast carefully.
                </p>
                <form ref="header-form">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label for="theme_name">
                        Theme Name <span class="text-danger">*</span>
                      </label>
                      <b-form-input
                        id="room_type"
                        type="text"
                        placeholder="Header Theme Name"
                        autocomplete="off"
                        v-model="headerData.name"
                      ></b-form-input>
                    </div>
                    <div class="col-md-12">
                      <label>Set Color</label>
                      <div class="d-flex flex-wrap align-items-center mb-3">
                        <b-form-group
                          v-for="(item, index) in colorData"
                          :key="index"
                          class="me-3 mb-3"
                          :label="index"
                          label-for="name-input"
                        >
                          <p slot="label" class="mb-2 text-capitalize">
                            {{ index.replaceAll("_", " ") }}
                          </p>
                          <b-form-input
                            class="form-control-color"
                            :id="index"
                            type="color"
                            :name="index"
                            v-model="colorData[index]"
                            @blur="colorChange($event, index)"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="form-check form-switch form-switch-md d-flex mb-3"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="single_multi_image"
                          v-model="headerData.isSingleImg"
                        />
                        <label for="single_multi_image" class="form-check-label"
                          >How will it look as Multi / Single Image</label
                        >
                      </div>
                    </div>
                    <div class="mt-3">
                      <b-button
                        class="float-end ms-3"
                        variant="outline-primary"
                        @click="deleteTheme()"
                      >
                        Delete
                      </b-button>

                      <b-button
                        class="float-end ms-3"
                        variant="outline-primary"
                        @click="handleHeaderSubmit()"
                        :class="{
                          disabled: isBtnLoading,
                        }"
                      >
                        <i
                          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                          v-if="isBtnLoading"
                        ></i
                        >Save
                      </b-button>

                      <b-button
                        class="float-end"
                        variant="outline-primary"
                        @click="resetHeaderData()"
                        :class="{
                          disabled: isResetBtnLoading,
                        }"
                      >
                        <i
                          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                          v-if="isResetBtnLoading"
                        ></i
                        ><span> Reset</span>
                      </b-button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<style scoped>
.category-options .form-check-input {
  min-width: 40px;
}
.template-dropdown {
  position: absolute;
  right: 0;
  top: 0;
}
.option-image {
  width: 50px;
}
.new-add-box {
  height: 100px;
}
.banner-img {
  height: 100px;
}

.menu-link p {
  position: absolute;
  bottom: 0px;
  padding: 10px;
}
.menu-link .form-check {
  position: absolute;
  top: 6px;
  right: 6px;
}
</style>

<style>
.menu-link .custom-checkbox .custom-control-input {
  width: 16px;
  height: 16px;
}

.hotel-btn {
  color: var(--template-btn-font) !important;
  background-color: var(--template-btn-bg) !important;
  border: 1px solid var(--template-btn-border) !important;
}
</style>
